// extracted by mini-css-extract-plugin
module.exports = {"empty":"_2442","message":"_15019","actions":"_13689","noMargin":"_3640"};